module.exports = __webpack_public_path__ + "static/img/Home29@2x.a5a4e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home29@2x.png
// module id = 91bk
// module chunks = 1